module.exports = __webpack_public_path__ + "img/snow_fall_00016.9ae6be59.png";